import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const DefaultAdminRoute = ({ perms }) => {
    const location = useLocation();

    const permWithDefaultAdminRoute = (perms || []).find(p => p.defaultAdminRoute);
    const to = permWithDefaultAdminRoute?.defaultAdminRoute || '/';

    return (
        <Navigate
            to={to}
            replace
            state={{ from: location }}
        />
    );
};

DefaultAdminRoute.propTypes = {
    perms: PropTypes.arrayOf(
        PropTypes.shape({
            defaultAdminRoute: PropTypes.string,
        }),
    ),
};

const mapStateToProps = state => ({
    perms: state.user.perms,
});

export default connect(mapStateToProps)(DefaultAdminRoute);
